(() => {
  const desktop = window.matchMedia('(min-width: 900px)');
  const slidesOf = (gallery) => Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
  function update(gallery, target, scroll) {
    const slides = slidesOf(gallery);
    if (!slides.includes(target)) return;
    const track = gallery.querySelector('[data-gallery-track]');
    gallery.dataset.selectedMedia = target.dataset.gallerySlide;
    slides.forEach((slide) => { slide.hidden = desktop.matches && slide !== target; });
    gallery.querySelectorAll('[data-gallery-target]').forEach((link) => {
      link.setAttribute('aria-current', String(link.dataset.galleryTarget === target.dataset.gallerySlide));
    });
    if (!desktop.matches && scroll) track.scrollTo({left: target.offsetLeft, behavior: 'auto'});
  }
  function initialize(root) {
    root.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
      gallery.classList.add('gallery-enhanced');
      const slides = slidesOf(gallery);
      const selected = slides.find((slide) => slide.dataset.gallerySlide === gallery.dataset.selectedMedia) || slides[0];
      if (selected) update(gallery, selected, true);
    });
  }
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('[data-gallery-target]');
    if (!link) return;
    const gallery = link.closest('[data-product-gallery]');
    const target = slidesOf(gallery).find((slide) => slide.dataset.gallerySlide === link.dataset.galleryTarget);
    if (!target) return;
    event.preventDefault();
    update(gallery, target, true);
  });
  let scrollPending = false;
  document.addEventListener('scroll', (event) => {
    if (!(event.target instanceof Element) || !event.target.matches('[data-gallery-track]') || desktop.matches || scrollPending) return;
    scrollPending = true;
    requestAnimationFrame(() => {
      scrollPending = false;
      const track = event.target;
      const gallery = track.closest('[data-product-gallery]');
      if (!gallery?.isConnected) return;
      const nearest = slidesOf(gallery).reduce((best, slide) => Math.abs(slide.offsetLeft - track.scrollLeft) < Math.abs(best.offsetLeft - track.scrollLeft) ? slide : best);
      update(gallery, nearest, false);
    });
  }, true);
  desktop.addEventListener('change', () => initialize(document));
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  initialize(document);
})();
